module.exports = __webpack_public_path__ + "img/New1.fad2f551.png";